import { render, staticRenderFns } from "./AddCorrectionButton.vue?vue&type=template&id=5bdc20cc&scoped=true&"
import script from "./AddCorrectionButton.vue?vue&type=script&lang=ts&"
export * from "./AddCorrectionButton.vue?vue&type=script&lang=ts&"
import style0 from "./AddCorrectionButton.vue?vue&type=style&index=0&id=5bdc20cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdc20cc",
  null
  
)

export default component.exports